<div class="signalr-status-container" *ngIf="enabled$ | async">
  <ng-container *ngIf="hubConnectionState$ | async as hubConnectionState">
    <span *ngIf="hubConnectionState === 'Connected'" title="Server Connected"
      ><i class="ra-icon-ide-sm-color-status-indicator-circle-check"></i
    ></span>
    <span *ngIf="hubConnectionState === 'Disconnected'" title="Disconnected"
      ><i class="ra-icon-ide-sm-color-status-indicator-circle-offline"></i
    ></span>
    <span *ngIf="hubConnectionState === 'Reconnecting'" title="Reconnecting"
      ><i class="ra-icon-ide-sm-color-status-indicator-circle-warning connecting"></i
    ></span>
    <span *ngIf="hubConnectionState === 'Connecting'" title="Connecting"
      ><i class="ra-icon-ide-sm-color-status-indicator-circle-info connecting"></i
    ></span>
    <span *ngIf="hubConnectionState === undefined" title="Offline"
      ><i class="ra-icon-ide-sm-color-status-indicator-circle-offline"></i
    ></span>
  </ng-container>
</div>
